import { createRouter, createWebHistory } from 'vue-router'
import BindSuccess from '@/views/install/BindSuccess.vue'
import LocateInstall from '@/views/install/LocateInstall.vue'
import ScanArea from '@/views/install/ScanArea.vue'
import ScanDevice from '@/views/install/ScanDevice.vue'
import ScanDeviceFullscreen from '@/views/install/ScanDeviceFullscreen.vue'

const routes = [
  {
    path: '/',
    redirect: '/install/area'
  },
  {
    path: '/index',
    redirect: '/install/area'
  },
  {
    path: '/install/area',
    name: 'InstallScanArea',
    component: ScanArea
  },
  {
    path: '/install/location',
    name: 'InstallLocate',
    component: LocateInstall
  },
  {
    path: '/install/device',
    name: 'InstallScanDevice',
    component: ScanDevice
  },
  {
    path: '/install/device/scan',
    name: 'InstallScanDeviceFullscreen',
    component: ScanDeviceFullscreen
  },
  {
    path: '/install/success',
    name: 'InstallBindSuccess',
    component: BindSuccess
  }
]
const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_BASE_PATH || '/'),
  routes
})

export default router
